import { SD, SportsMessageChannels, } from "../../../../../Contracts";
import { isValidEventState, isValidDateRange_from, isValidDateRange_timeRange } from "../../Helpers";
export const validatioFailures = {
    unexpectedProp: (x) => `Unexpected property passed to query: "${x}".
    Valid contract: {
        eventState?: SDQueryEventState
        dateRange?: DateRange
    }`,
    name: (x) => `Bad query name passed "${x}". Expected to receive "${SportsMessageChannels.GetSports}"`,
    eventState: (x) => `Bad event state passed "${x}". Expected one of:
    - ${Object.values(SD.EventState).join(",\n\t- ")}`,
    dateRange: {
        invalidRoot: () => `Invalid dateRange passed. dateRange must be of the type: "{
            from?: string
            timeRange: SDQueryTimeRange
        }"`,
        unknownProp: (x) => `Unexpected property passed to dateRange: "${x}"`,
        from: (x) => `Invalid value passed for "from": "${x}". Value must be deserializable to a Date object.`,
        timeRange: (x) => `Ivalid value passed for "timeRange": "${x}". Value must be one of:\n\t- ${Object.values(SD.TimeRange).join(",\n\t- ")}`
    }
};
const nestedPropsValidator = {
    dateRange: {
        from: isValidDateRange_from,
        timeRange: isValidDateRange_timeRange
    }
};
const validators = {
    dateRange(dateRange) {
        if (typeof dateRange === "undefined") {
            return true;
        }
        if (typeof dateRange !== "object" || Array.isArray(dateRange)) {
            throw new Error(validatioFailures.dateRange.invalidRoot());
        }
        Object.keys(dateRange).forEach(x => {
            if (typeof nestedPropsValidator.dateRange[x] !== "function") {
                throw new Error(validatioFailures.dateRange.unknownProp(x));
            }
            if (typeof dateRange[x] !== "undefined" &&
                !nestedPropsValidator.dateRange[x](dateRange[x])) {
                throw new Error(validatioFailures.dateRange[x](dateRange[x]));
            }
        });
        return true;
    },
    eventState(eventState) {
        if (typeof eventState === "undefined") {
            return true;
        }
        if (!isValidEventState(eventState)) {
            throw new Error(validatioFailures.eventState(eventState));
        }
        return true;
    }
};
export const sportsParams = (q) => {
    if (typeof q === "undefined") {
        return true;
    }
    if (q.name !== SportsMessageChannels.GetSports) {
        throw new Error(validatioFailures.name(q.name));
    }
    q.params && Object.keys(q.params).forEach(x => {
        if (typeof validators[x] !== "function") {
            throw new Error(validatioFailures.unexpectedProp(x));
        }
        validators[x](q.params[x]);
    });
    return true;
};
//# sourceMappingURL=SportsParams.js.map